// src/services/positionService.js
import axios from '@/api'

export default {
  getAll() {
    return axios.get('/positions')
  },
  create(data) {
    return axios.post('/positions', data)
  },
  update(id, data) {
    return axios.put(`/positions/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/positions/${id}`)
  },
  toggleStatus(id) {
    return axios.patch(`/positions/${id}/changeStatus`)
  }
}
